import { LL } from 'i18n/i18n.service';
import { CameraPermissionHelpVariant } from 'services/camera-permission-help';

/**
 * The translated "how to switch the camera back on" steps for one variant.
 *
 * Every variant is listed explicitly and there is no fallback arm: a variant
 * added later without its steps is a TypeScript error here rather than a card
 * that quietly shows the browser instructions on a device that has no browser
 * controls — which is the exact failure #5139 was reported for.
 */
export function cameraPermissionSteps(variant: CameraPermissionHelpVariant): string[] {
  switch (variant) {
    case CameraPermissionHelpVariant.NativeAndroid:
      return [
        LL.cameraPermission.nativeAndroidStep1(),
        LL.cameraPermission.nativeAndroidStep2(),
        LL.cameraPermission.nativeAndroidStep3(),
        LL.cameraPermission.nativeAndroidStep4(),
        LL.cameraPermission.nativeAndroidStep5(),
      ];
    case CameraPermissionHelpVariant.NativeIos:
      return [
        LL.cameraPermission.nativeIosStep1(),
        LL.cameraPermission.nativeIosStep2(),
        LL.cameraPermission.nativeIosStep3(),
        LL.cameraPermission.nativeIosStep4(),
      ];
    case CameraPermissionHelpVariant.WebIosSafari:
      return [
        LL.cameraPermission.webIosStep1(),
        LL.cameraPermission.webIosStep2(),
        LL.cameraPermission.webIosStep3(),
        LL.cameraPermission.webIosStep4(),
        LL.cameraPermission.webIosStep5(),
      ];
    case CameraPermissionHelpVariant.WebIosOtherBrowser:
      return [
        LL.cameraPermission.webIosOtherBrowserStep1(),
        LL.cameraPermission.webIosOtherBrowserStep2(),
        LL.cameraPermission.webIosOtherBrowserStep3(),
        LL.cameraPermission.webIosOtherBrowserStep4(),
      ];
    case CameraPermissionHelpVariant.WebMacSafari:
      return [
        LL.cameraPermission.macSafariStep1(),
        LL.cameraPermission.macSafariStep2(),
        LL.cameraPermission.macSafariStep3(),
        LL.cameraPermission.macSafariStep4(),
      ];
    case CameraPermissionHelpVariant.WebOther:
      return [
        LL.cameraPermission.webStep1(),
        LL.cameraPermission.webStep2(),
        LL.cameraPermission.webStep3(),
        LL.cameraPermission.webStep4(),
      ];
  }
}
